import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from './constants';

const wallboardHeartbeatConverter = {
  toFirestore(
    heartbeat: WallboardHeartbeats.Heartbeat,
  ): firebase.firestore.DocumentData {
    return { ...heartbeat };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): WallboardHeartbeats.Heartbeat {
    return snapshot.data(options) as WallboardHeartbeats.Heartbeat;
  },
};

// One doc per wallboard per TV (`${wallBoardId}:${deviceId}`). Kept apart from
// wallBoards so a heartbeat doesn't fire every client's wallBoards listener.
const getWallboardHeartbeatsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.WALLBOARD_HEARTBEATS_COLLECTION)
    .withConverter(wallboardHeartbeatConverter);
};

export default getWallboardHeartbeatsRef;
